import { render, staticRenderFns } from "./CouponActive.vue?vue&type=template&id=3e6f4e72&"
import script from "./CouponActive.vue?vue&type=script&lang=js&"
export * from "./CouponActive.vue?vue&type=script&lang=js&"
import style0 from "./CouponActive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports